import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { SearchBar } from "@/components/SearchBar";
import { Gallery } from "@/components/Gallery";
import { Marquee } from "@/components/Marquee";
import { MapSection } from "@/components/MapSection";
import { ReviewsSection } from "@/components/ReviewsSection";
import { RemoteWork } from "@/components/RemoteWork";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { LongstayStrip } from "@/components/LongstayStrip";

export default function Home() {
  return (
    <div data-testid="home-page">
      <div className="noise-overlay" />
      <Navbar />
      <Hero />
      <SearchBar />
      <LongstayStrip />
      <Gallery />
      <Marquee />
      <MapSection />
      <ReviewsSection />
      <RemoteWork />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
